module.exports = __webpack_public_path__ + "img/google.7c88ffc0.svg";